export enum VIEW_MODE {
  GRID = 'GRID',
  LIST = 'LIST',
}
